module.exports = __webpack_public_path__ + "static/media/item_3_6_comp.242da96c.png";